import React from 'react';
import { Chip } from '@mui/material';
import './StatusChip.css';

export type StatusType = 
  | 'active' 
  | 'pending' 
  | 'suspended' 
  | 'success' 
  | 'warning' 
  | 'danger' 
  | 'info'
  | 'you'
  | 'superadmin'
  | 'archived';

export interface StatusChipProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, label, className = '' }) => {
  // Default labels based on status type
  const defaultLabels: Record<StatusType, string> = {
    active: 'Active',
    pending: 'Pending',
    archived: 'Archived',
    suspended: 'Suspended',
    success: 'Success',
    warning: 'Warning',
    danger: 'Danger',
    info: 'Info',
    you: 'You',
    superadmin: 'Superadmin',
  };

  const displayLabel = label || defaultLabels[status];

  return (
    <Chip
      label={displayLabel}
      className={`status-chip status-chip-${status} ${className}`}
      sx={{
        '& .MuiChip-label': {
          padding: '0px 12px',
        },
      }}
    />
  );
};

export default StatusChip;

